export function ContentsquareTracker(): React.JSX.Element {
  return <script async src="https://t.contentsquare.net/uxa/997ea8eb89528.js" />;
}
